import {isMobile} from "react-device-detect";
import {config} from "../../../config";


export const Advices = {
    oneAdvise: null,

    advicesList: [
        "To start a battle, your deck must contain at least 50 cards.",
        "Double tap or double click on a card to reveal its bigger size.",

        "Earn Soul Stones by advancing through the Arena season.",
        "Got a 6th copy of a card? It transforms into Soul Stones instead of cluttering your collection.",
        "You can only have up to 5 copies of the same card in your collection. If you receive a 6th copy, it is automatically converted into Soul Stones or Divine Essence.",

        "Divine Essence awaits those who progress through the Arena — and those worthy of the Champion title.",
        "Seek greater rewards — Divine Essence can also be earned in Bonus Levels."
    ],



    get: function () {

        if(isMobile && !config.isAndroid){
            return 'For the best experience, we recommend using the Android app or playing in Google Chrome on desktop, as mobile browsers may be unstable.';
        }

        if (Advices.oneAdvise === null) {
            // @ts-ignore
            Advices.oneAdvise = Advices.advicesList[(Math.floor(Math.random() * Advices.advicesList.length))];
        }

        return Advices.oneAdvise;
    }

}